// Las teclas del chat abierto: Esc lo cierra (si no estás escribiendo) y Alt+↑/↓ pasa al agente anterior/siguiente EN EL
// ORDEN QUE SE VE en la lista (misma bandeja, mismos grupos, con «Con Santi»). Una sola pieza (03-11: el chat recorría todos
// los agentes sin «Con Santi» y saltaba en otro orden que la lista).
import { useEffect } from 'react';
import type { ContratadoDTO } from '../compartido/vocabulario';
import { useBandeja } from '../marco/useBandeja';
import { useOrdenEquipo } from '../marco/useOrdenEquipo';
import { useOficinaStore } from '../store';

export function useTeclasChat({ agentId, contratados, alCambiar, alCerrar }: { agentId: string; contratados: Record<string, ContratadoDTO>; alCambiar: (agentId: string) => void; alCerrar: () => void }): void {
  const { visibles } = useBandeja(contratados);
  const lista = useOrdenEquipo(visibles);
  useEffect(() => {
    const alTeclear = (e: KeyboardEvent) => {
      // Con una ventana (contratar, plan, cerrar) encima, sus teclas son suyas.
      if (useOficinaStore.getState().contratarAbierto || document.querySelector('[role="dialog"]')) return;
      const destino = e.target as HTMLElement | null;
      const escribiendo = !!destino && (destino.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(destino.tagName));
      const vacio = !escribiendo || !(destino as HTMLInputElement).value;
      if (e.key === 'Escape' && !e.defaultPrevented && vacio) alCerrar();
      if (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp') && lista.length) {
        e.preventDefault();
        const i = lista.findIndex((x) => x.agentId === agentId);
        const paso = e.key === 'ArrowDown' ? 1 : lista.length - 1;
        const sig = lista[i < 0 ? 0 : (i + paso) % lista.length];
        if (sig) alCambiar(sig.agentId);
      }
    };
    window.addEventListener('keydown', alTeclear);
    return () => window.removeEventListener('keydown', alTeclear);
  }, [agentId, alCambiar, alCerrar, lista]);
}
